import { render, staticRenderFns } from "./AlarmSensorsBlock.vue?vue&type=template&id=86d818c6&scoped=true&"
import script from "./AlarmSensorsBlock.vue?vue&type=script&lang=js&"
export * from "./AlarmSensorsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d818c6",
  null
  
)

export default component.exports